import React, { useEffect, useState } from "react";
import {
  FaBuilding,
  FaIndianRupeeSign,
  FaLocationDot,
  FaPlus,
} from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import apiClient from "../api.js";

const CompareProperty = () => {
  const location = useLocation();
  const [name, setname] = useState("");
  const [results, setResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([
    null,
    null,
    null,
  ]);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [showComparison, setShowComparison] = useState(false);

  useEffect(() => {
    if (location.state?.propertyId) {
      fetchPropertyById(location.state.propertyId);
    }
  }, [location.state?.propertyId]);

  const fetchPropertyById = async (id) => {
    try {
      const response = await apiClient.get(`listing/get/${id}`);
      if (response.status === 200 && response.data) {
        setSelectedProperties((prev) => {
          const newArr = [...prev];
          newArr[0] = response.data;
          return newArr;
        });
      }
    } catch (error) {
      console.error("Error fetching compare property by ID:", error);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (name) {
        fetchSearchResults(name);
      } else {
        setResults([]);
        setHasSearched(false);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(delayDebounceFn);
  }, [name]);

  const fetchSearchResults = async (term) => {
    try {
      const response = await apiClient.post("listing/compare", {
        name: term,
      });

      const properties = response.data;

      setResults(properties);
      setHasSearched(true);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const handleChange = (e) => {
    setname(e.target.value);
  };

  const handleAddProject = (index) => {
    setCurrentSlot(index);
  };

  const handleSelectProperty = (property) => {
    if (currentSlot !== null) {
      setSelectedProperties((prev) => {
        const newArr = [...prev];
        newArr[currentSlot] = property;
        return newArr;
      });
      setShowComparison(false);
      // Close modal
      const modal = document.getElementById("searchModal");
      const bsModal = window.bootstrap.Modal.getInstance(modal);
      bsModal.hide();
      setCurrentSlot(null);
      setname("");
      setResults([]);
      setHasSearched(false);
    }
  };

  const handleCompare = () => {
    setShowComparison(true);
  };

  const handleReset = () => {
    setSelectedProperties([null, null, null]);
    setShowComparison(false);
  };

  const renderSlot = (index) => {
    const property = selectedProperties[index];
    if (property) {
      return (
        <div className="col-md-4">
          <div className="discounted-deal-property-div">
            <img
              src={property.imageUrls}
              className="discounted-property-img img-fluid"
              alt={`Discounted property ${property.name}`}
            />
            <div className="disocunted-property-specs-div">
              <p className="discounted-property-name view-detail-btn-property-home-txt">
                {property.name}
              </p>
              <p className="discounted-property-address-txt">
                <FaLocationDot />
                <span>{property.address}</span>
              </p>
              <p className="discounted-property-BHK-txt">
                <FaBuilding />
                {property.BHK && Array.isArray(property.BHK) ? (
                  property.BHK.map((bhk, idx) => (
                    <span key={idx}>
                      {bhk}
                      {idx < property.BHK.length - 1 && ", "}
                    </span>
                  ))
                ) : (
                  <span>Loading data...</span>
                )}{" "}
                BHK
              </p>
              <p className="discounted-property-price">
                <FaIndianRupeeSign />
                <span>{property.price}</span>
              </p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-md-4">
          <div
            className="compare-main-div"
            data-bs-toggle="modal"
            data-bs-target="#searchModal"
            onClick={() => handleAddProject(index)}
          >
            <FaPlus className="plus-sign" />
            <p>Add Project</p>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="banner-heading-h2">Property Comparison</h1>
          </div>
          <div className="row my-3">
            {renderSlot(0)}
            {renderSlot(1)}
            {renderSlot(2)}
            <div className="col-md-12 mt-4 align-self-center">
              <button
                type="button"
                onClick={handleReset}
                className="get-call-btn-property-home-page me-3"
              >
                Remove
              </button>
              <button
                type="button"
                onClick={handleCompare}
                className="get-call-btn-property-home-page me-3"
                disabled={selectedProperties.filter(Boolean).length < 2}
              >
                Compare
              </button>
            </div>
          </div>
        </div>
        {showComparison && selectedProperties.filter(Boolean).length > 0 && (
          <div className="row mt-4">
            <div className="col-md-12">
              <h2 className="mb-3">Comparison Table</h2>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Property Name</th>
                    {selectedProperties.map((property, idx) => (
                      <th key={idx}>
                        {property ? property.name : `Slot ${idx + 1}`}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Address</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>{property?.address || "-"}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>BHK</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>
                        {property?.BHK && Array.isArray(property.BHK)
                          ? property.BHK.join(", ")
                          : "-"}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>Price</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>{property?.price || "-"}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Area</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>
                        {property?.sqftMin && property?.sqftMax
                          ? `${property.sqftMin.join(", ")} - ${property.sqftMax.join(", ")} Sq.ft.`
                          : "-"}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th>Developer</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>{property?.devlopername || "-"}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Possession</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>{property?.possessiondate || "-"}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Property Type</th>
                    {selectedProperties.map((property, idx) => (
                      <td key={idx}>{property?.propertytype || "-"}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="searchModal"
        tabIndex={-1}
        aria-labelledby="searchModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title fs-6" id="searchModalLabel">
                Pick the properties to compare.
              </h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form>
                <div className="input-wrapper text-center">
                  <FaSearch className="search-icon" />
                  <input
                    value={name}
                    onChange={handleChange}
                    id="searchPropertyInput"
                    className="search-input"
                    placeholder="Location, Property, Developer"
                  />
                  <button className="search-btn">Search</button>
                </div>
              </form>
              <div className="search-results mt-3">
                {results.length > 0 ? (
                  <ul className="list-group">
                    {results.map((property) => (
                      <li
                        key={property._id}
                        className="list-group-item"
                        onClick={() => handleSelectProperty(property)}
                        style={{ cursor: "pointer" }}
                      >
                        {property.name}
                      </li>
                    ))}
                  </ul>
                ) : hasSearched ? (
                  <p className="text-muted">No results found.</p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompareProperty;
